import { DataResult, getter } from "@progress/kendo-data-query";

interface CommandDeleteRowProps<T> {
  readonly idField: string;
  readonly dataResult: DataResult;
  readonly setDataResult: (dataResult: DataResult) => void;
  readonly dataItem: T;
}

export default function commandDeleteRow<T>({
  idField,
  dataResult,
  setDataResult,
  dataItem,
}: CommandDeleteRowProps<T>) {
  const updatedData = dataResult.data.filter(
    (x) => getter(idField)(x) !== getter(idField)(dataItem)
  );
  setDataResult({
    data: updatedData,
    total: updatedData.length,
  });
}
